import { render, staticRenderFns } from "./connect-clients.page.vue?vue&type=template&id=f7cfa0da&scoped=true&"
import script from "./connect-clients.page.vue?vue&type=script&lang=js&"
export * from "./connect-clients.page.vue?vue&type=script&lang=js&"
import style0 from "./connect-clients.page.vue?vue&type=style&index=0&id=f7cfa0da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cfa0da",
  null
  
)

export default component.exports